import moment from "moment";

const formatYearMonthDate = (dateTime) => {
  return moment(new Date(dateTime)).format("yyyy-MM-dd");
};

export default formatYearMonthDate;
//TimeYearMonthDate;

export const TimeBigYearMonthDate = (dateTime) => {
  return moment(new Date(dateTime)).format("YYYY-MM-DD");
};

export const TimeDateMonthYear = (dateTime) => {
  return moment(new Date(dateTime)).format("dd/MM/yyyy");
};

export const TimeDateMonthSmallYear = (dateTime) => {
  return moment(new Date(dateTime)).format("dd/MM/yy");
};
export const DateHourMinute = (dateTime) => {
  return moment(new Date(dateTime)).format("HH:mm");
};
